import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Markdown } from "@conserveit/blocks";
import { Link } from "react-router-dom";
import Loading from "../../Loading";
import {
  Wrapper,
  Inner,
  Content,
  Row,
  Summary,
  Targets,
  Description,
  QuickLink,
  SectionHeading,
  LoadingWrapper,
} from "./IssuePreview.styles";

const IssuePreview = ({ data, isOpen }) => (
  <Wrapper isOpen={isOpen}>
    <Inner>
      {!data && (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      )}
      {data && (
        <Fragment>
          <Content>
            <Row>
              <h3>{data.components}</h3>
            </Row>
            <Row>
              Priority: <strong>{data.priority}</strong>
            </Row>
            <Row>
              Status: <strong>{data.bonfire_status}</strong>
            </Row>
            <Summary>{data.summary}</Summary>
            <Targets>
              <SectionHeading>RELATED TARGETS</SectionHeading>
              <ul>
                {data.relatedEquipRules.map((equipRule) => (
                  <li key={equipRule.id}>{equipRule.target.name}</li>
                ))}
              </ul>
            </Targets>
            {data.description && (
              <Description>
                <SectionHeading>DESCRIPTION</SectionHeading>
                <Markdown source={data.description} />
              </Description>
            )}
          </Content>
          <QuickLink>
            <Link to={`/issue/${data.key}`} href={`/issue/${data.key}`}>
              View Action (#{data.key})
            </Link>
          </QuickLink>
        </Fragment>
      )}
    </Inner>
  </Wrapper>
);

IssuePreview.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
};

IssuePreview.defaultProps = {
  isOpen: false,
  data: undefined,
};

export default IssuePreview;
